// Display formatting for freight/tariff charge rules (freight_tariff_rule rows from
// /api/admin/freightrules and /api/user/freight/...). Charges are display-only
// (not part of the price calculation), so everything here is string building.

const isSet = (v) => v !== null && v !== undefined && v !== '';

const money = (v) => `$${Number(v).toFixed(2)}`;

// 4.5 -> "4.5", 38.0 -> "38"
const pct = (v) => String(parseFloat(Number(v).toFixed(3)));

// "4.5% of cost + $50.00 + $0.74/SY, min $65.00, cap $60.00" — or "No charge"
// when the only component is an explicit zero (vendor ships free).
export const chargeRateText = (charge) => {
  const parts = [];
  if (isSet(charge.percent_of_cost) && Number(charge.percent_of_cost) !== 0) {
    parts.push(`${pct(charge.percent_of_cost)}% of cost`);
  }
  if (isSet(charge.flat_amount) && Number(charge.flat_amount) !== 0) {
    parts.push(money(charge.flat_amount));
  }
  if (isSet(charge.per_unit_amount) && Number(charge.per_unit_amount) !== 0) {
    parts.push(`${money(charge.per_unit_amount)}/${charge.per_unit_uom_type_cd || 'unit'}`);
  }

  if (!parts.length) return 'No charge';

  let text = parts.join(' + ');
  if (isSet(charge.min_charge)) text += `, min ${money(charge.min_charge)}`;
  if (isSet(charge.max_charge)) text += `, cap ${money(charge.max_charge)}`;
  return text;
};

// One line per charge: "Tile Delivery: $75.00 (under $500 order is $200)"
export const chargeLineText = (charge) =>
  `${charge.charge_name}: ${chargeRateText(charge)}${charge.notes ? ` (${charge.notes})` : ''}`;

export const splitByType = (charges) => ({
  freight: (charges || []).filter((c) => c.charge_type_cd !== 'TARIFF'),
  tariff: (charges || []).filter((c) => c.charge_type_cd === 'TARIFF'),
});

// NOTE: dollar estimates are deliberately NOT computed here. The one estimate
// calculation lives server-side (server freight controller,
// estimateChargesTotal) and is served to staff and customers via
// /api/user/freight/estimate and /api/user/freight/customer/estimate.
